"use strict";

(function () {
  "use strict";

  config.$inject = ["$stateProvider"];
  angular.module("customers").config(config);

  function config($stateProvider) {}
})();